export default __webpack_public_path__ + "static/media/redBook.a2a6349f.png";